import React, {useContext} from 'react';
import {AuthContext} from "../../../../config/AuthContext";
import {Button, Col, ConfigProvider, Form, Input, Modal, Row, Popconfirm} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {PostRebutFraccionat} from '../../../../dao/multilleure/administracio/PostRebutFraccionat';
import {QuestionCircleOutlined} from "@ant-design/icons";

interface RebutFracionarModalProps {
    element: object | undefined;
    visible: boolean;
    onClose: (value: boolean) => void;
}

const RebutFracionarModal: React.FC<RebutFracionarModalProps> = ({element, visible, onClose}) => {
    const [form] = Form.useForm();
    const {userId, page} = useContext(AuthContext);

    const handleSubmit = async () => {
        const formData = form.getFieldsValue();
        await PostRebutFraccionat(element, page, userId, formData.num_fraccionar);
        onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Fraccionar rebut"
                open={visible}
                onCancel={handleCancel}
                footer={null}
                width="30%"
                destroyOnClose
            >
                <Form
                    form={form}
                    initialValues={element}
                    onFinish={handleSubmit}
                    layout="vertical"
                >
                    <hr/>
                    <Form.Item
                        label="A quants rebuts es vol fraccionar"
                        name="num_fraccionar"
                        rules={[
                        { required: true, message: 'Aquest camp és obligatori' },
                        {
                            validator: (_, value) =>
                                value >= 2
                                    ? Promise.resolve()
                                    : Promise.reject(new Error('El número ha de ser com a mínim 2')),
                        },
                    ]}
                    >
                    
                    <Input type="number"/>
                    </Form.Item>

                    <hr/>
                    <Row gutter={16}>
                        <Col>
                            <Popconfirm
                                title="Vols fraccionar definitivament aquest element?"
                                icon={<QuestionCircleOutlined style={{color: 'red'}} />}
                                onConfirm={() => form.submit()}
                                okText="Si"
                                cancelText="No"
                            >
                                <Button
                                    title={"Aceptar"}
                                    style={{backgroundColor: Colors.colors.color6, borderColor: Colors.colors.color6}}
                                ><BiCheck />
                                </Button>
                            </Popconfirm>
                        </Col>
                        <Col>
                            <Button title={"Cancelar"}onClick={handleCancel}
                                style={{backgroundColor: Colors.colors.color1, borderColor: Colors.colors.color1}}
                            ><BiX />
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default RebutFracionarModal;
